import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { BACKEND } from "../../../config/configEnvs";
import ModalInDrawer from "../../ui/ModalInDrawer";
import CallSection from "../CallSection";
import LoadingScreen from "../../ui/temp-screens/LoadingScreen";

const OpenCallsModal = ({ open, onClose, quoteId, clientData }) => {
  const [calls, setCalls] = useState([]);
  const [loading, setLoading] = useState(false);

  const getCalls = async () => {
    if (!quoteId) return;
    try {
      setLoading(true);
      const url = `${BACKEND}/api/registroLlamadas?where[quotes][contains]=${quoteId}&limit=0`;
      const response = await axios.get(url);
      setCalls(response.data.docs || []);
    } catch (error) {
      toast.error("Error al obtener las llamadas");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) getCalls();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, quoteId]);

  return (
    <ModalInDrawer
      activeModal={open}
      onClose={onClose}
      title="Llamadas telefónicas"
      centered
      className="max-w-6xl"
      scrollContent={false}
    >
      {loading ? (
        <div className="h-[15rem]">
          <LoadingScreen text="Cargando llamadas..." />
        </div>
      ) : (
        <CallSection
          calls={calls}
          refetch={getCalls}
          clientData={clientData}
          quoteId={quoteId}
        />
      )}
    </ModalInDrawer>
  );
};

export default OpenCallsModal;